


































import { Component, Mixins, Watch } from "vue-property-decorator";
import { DialogMixin } from "../mixins";
import DateSelector from "../selectors/DateSelector.vue";

@Component({
  components: {
    DateSelector,
  }
})
export default class DateSelectDialog extends Mixins(DialogMixin) {
  $refs!: {
    dateSelector: DateSelector;
  };

  data(): any {
    return {
      selectedDate: null as Date,
      selectedInfo: null as Date,
    };
  }
  selectedDate: Date;
  selectedInfo: Date;

  async show(date: Date): Promise<Date> {
    return this.showModal(async () => {
      this.selectedDate = date
        ? date
        : new Date();
      this.selectedInfo = date;
      await this.waitHidden();
      return this.selectedInfo;
    });
  }

  applyValue(value: Date) {
    this.selectedInfo = value;
    this.isVisible = false;
  }

  cancel(): void {
    this.selectedInfo = undefined;
    this.isVisible = false;
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean) {
    if (newValue) {
      this.$nextTick(() => {
        if (this.$refs.dateSelector) {
          this.$refs.dateSelector.setFocus();
        }
      });
    }
  }
}
